import { createSelector } from '@reduxjs/toolkit';

import { AppState } from '../reducers/root';
import { ErrorNotification } from '../slices/error';

export const hasPendingErrors = createSelector(
  (state: AppState) => state.errors.errorNotifications.length,
  length => length !== 0
);

export const getFirstPendingError = (
  state: AppState
): ErrorNotification | undefined => state.errors.errorNotifications[0];
